import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestForwardEndpointsGet = {
    path: "/forward/endpoints",
    method: RouteHttpVerb.GET
};
export { locationRestForwardEndpointsGet };
